// @flow
import React from "react"
import { sortBy, prop } from "ramda"
import { compose, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import withQuery from "hoc/withQuery"
import { filterableParametersQuery } from "data/search/graphql/queries/params"
import { selectSearchParams } from "data/search/selectors"
import { selectProductGroups, selectGeolocation } from "data/app/selectors"
import type { EnumValue } from "data/enums/types"
import Multiselect from "searchFilters/Shared/Multiselect"

const EnumFilter = ({ data, onChange, value, paramKey }) => {
  const paramData = data && data[paramKey]
  if (!paramData || paramData.type !== "enum_value") return null

  // Evaluate if enums have an order
  const allValuesAreOrdered = paramData.enum.values.every(enumValue => enumValue.order !== null)
  const orderedEnumValues = allValuesAreOrdered ?
   sortBy(prop("order"), paramData.enum.values):
   sortBy(prop("name"), paramData.enum.values)

  return (
    <Multiselect
      options={orderedEnumValues}
      value={value}
      onChange={onChange}
    />
  )
}

const mapStateToProps = state => ({
  params: selectSearchParams(state),
  productGroups: selectProductGroups(state),
  geolocation: selectGeolocation(state),
})

type Outter = {|
  onChange: (?(EnumValue[])) => mixed,
  value: ?(EnumValue[]),
  paramKey: string,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(mapStateToProps),
  withQuery(filterableParametersQuery, {
    variables: props => ({
      productGroups: props.productGroups && props.productGroups.map(productGroup => productGroup.name),
      locationIds: props.geolocation && props.geolocation.map(geo => geo.id),
      affiliateIds: props.params.affiliate ? [props.params.affiliate] : undefined,
    }),
    noLoader: true,
    noEmpty: true,
  }),
)

export default enhancer(EnumFilter)



// WEBPACK FOOTER //
// ./src/searchFilters/Shared/EnumFilter/index.js